const deployEnv = require('@ebay/environment-ebay');

// get the value of the env set by the deploy scripts
/**
 * environment-ebay can be called only on server rendered components
 * When component is called from client side, the process.env in deployEnv is not available
 * Relying on window for client side component load in catch block
 * The url path for micro-frame or ajax call are determined by the env variable set
 * For testing the app that includes our component in local environment or FP,
 * the component will load the qa path so that data is available.
 * All other environments load relative path.
 */

const getEnvFromWindow = () => {
    if (typeof window !== 'undefined') {
        const path = window.location.host;
        if (path.indexOf('qa.ebay.com') > -1 || path.indexOf('localhost') > -1) {
            return 'development';
        }
        return 'production';
    }
    return null;
};

const getEnvFromDeployEnv = () => {
    try {
        if (deployEnv.isDev()) {
            return 'development';
        } else if (deployEnv.isStage()) {
            return 'staging';
        } else if (deployEnv.isPreProd()) {
            return 'pre-production';
        }
    } catch (err) {
        return 'production';
    }
    return 'production';
};

const getEnv = () => {
    const envVal = getEnvFromWindow();
    if (envVal) return envVal;

    return getEnvFromDeployEnv();
};

/**
 * @param {string} env - deployed environment
 * @returns {string} basepath for the social-share-template endpoint
 */
const getSocialShareBasePath = (env) => env === 'development' || env === 'test'
    ? 'https://www.qa.ebay.com/str/svc/social-share-template/'
    : '/str/svc/social-share-template/';

const getGenericShareTemplatePath = (env) => env === 'development' || env === 'test'
    ? 'https://www.qa.ebay.com/str/svc/generic-share-template/'
    : '/str/svc/generic-share-template/';

module.exports = {
    getEnv,
    getEnvFromWindow,
    getEnvFromDeployEnv,
    getSocialShareBasePath,
    getGenericShareTemplatePath
};
